// find all Vimeo embeds in modals in case they need to be paused
var vimeoPlayers = [];
var embeds = document.querySelectorAll('.embed-vimeo');
for (var i=0; i<embeds.length; i++) {
	vimeoPlayers.push({
		player: new Vimeo.Player(embeds[i].querySelector('iframe'))
	})
}

// when modal is closed, pause video
$('.video-modal').on('hidden.bs.modal', function (e) {	
	
	var videos = document.getElementsByTagName('video');
	
	for (var i=0; i<videos.length; i++) {
		videos[i].pause();
	}
	
	// also find and pause Vimeo videos in iframes
	for (var i=0; i<vimeoPlayers.length; i++) {
		vimeoPlayers[i].player.pause();
	}
	
	
});

document.addEventListener('click', function (event) {
	
	// for mobile screens, when user clicks an anchor link to a section of the current page, make sure the menu closes
	if ( event.target.closest('#headerNav a') ) {
		$('#headerNav').collapse('hide'); // jquery / bootstrap 4 dependency
	}
	
	if ( event.target.closest('.video-chapters a') ) {
		event.preventDefault();
		var link = event.target.closest('.video-chapters a');
		var timecode = link.getAttribute('data-seek');
		var section = event.target.closest('section');
		var video = section.querySelector('.embed-vimeo iframe');
		if (video) {
			var vimeoPlayer = new Vimeo.Player(video);
			
			vimeoPlayer.setCurrentTime(timecode).then(function(seconds) {
				vimeoPlayer.play();
			}).catch(function(error) {
				switch (error.name) {
					case 'RangeError': 
						// The time is less than 0 or greater than the video's duration
						break;
			
					default: 
						// Some other error occurred
						break;
				}
			}); 
		}
	}
	
	// for mobile screens, when user clicks a link to a section of the current page, 
	// make sure the menu closes
	if ( event.target.closest('.nav-main a') ) {
		$('#headerNav').collapse('hide'); // bootstrap 4 jquery dependency
	}
	
}, false);


// FAQ page 
var faqGroups = document.querySelectorAll('.faq-nav .collapse');
for( i=0; i < faqGroups.length; i++) {
	
	$(faqGroups[i]).on('show.bs.collapse', function () {
	  var trigger = this.parentNode.querySelector('.btn .icon');
	  addClass(trigger, 'open');
	})
	
	$(faqGroups[i]).on('hide.bs.collapse', function () {
	  var trigger = this.parentNode.querySelector('.btn .icon');
	  removeClass(trigger, 'open');
	})
}

// hide TOP button unless page has been scrolled down
if(faqGroups.length) {
	window.addEventListener('scroll', function() {
		var faqNav = document.querySelector('.faq-nav');
		var topBtn = document.querySelector('.btn-faq-top');
		var minScroll = faqNav.offsetHeight / 2;
		var scrollpos = window.pageYOffset;
		
		if(scrollpos > minScroll){
			removeClass(topBtn, 'd-none');
		}
		else {
			addClass(topBtn, 'd-none');
		}
	});
}



// copy url to clipboard
var copyBtn = document.getElementById('btn-copy');
copyBtn.addEventListener('click', function() {
	
	if (!navigator.clipboard) {
	  // Clipboard API not available
	  return;
	}
	
	var shareUrl = document.getElementById('shareUrl');
	var text = shareUrl.value;
	
	try {
		  navigator.clipboard.writeText(text);
		  var status = document.getElementById('copy-status');
		  removeClass(status, 'opacity-0');
		  setTimeout(function () {
			addClass(status, 'opacity-0');
		  }, 2500);
		} catch (err) {
		  console.error('Failed to copy!', err);
		}
	  },
	  false
);

// open social links in popup
var socialButtons = document.querySelectorAll('.share-social');
for(var i=0; i < socialButtons.length; i++) {
	socialButtons[i].addEventListener('click', function(e) {
		e.preventDefault();
		var socUrl = this.getAttribute('href');
		openSocialWindow(socUrl);
	}, false);
}

function openSocialWindow(socUrl) {
	const left = (screen.width - 570) / 2;
	const top = (screen.height - 570) / 2;
	const params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
	window.open(socUrl, "NewWindow", params);
}


// show Events alert
window.addEventListener('load', function() {
	
	let eventsAlert = document.getElementById('events-alert');
	if (eventsAlert) {

		setTimeout(() => {
		
			// see if popup is open
			let usPopup = document.getElementById('usPopup');
			if (usPopup && usPopup.classList.contains('show')) {
				// The us dialog is open.
				console.log('us popup is open');
			} else {
				setTimeout(() => {
		
					// see if popup is open
					let eventPopup = document.getElementById('eventPopup');
					if (eventPopup && eventPopup.classList.contains('show')) {
						console.log('event popup is open');
						
						let okBtn = document.querySelector('#eventPopup .btn-cancel');
						okBtn.addEventListener('click', function (event) {
							setTimeout(() => {
								eventsAlert.classList.add('show');
							}, "1000");
							
						}, false);
						
					} else {
						console.log('show events alert')
						eventsAlert.classList.add('show');
					}
				
				}, "500");
			}
		
		}, "500");
				
	}
	
});

// handle view video netlify form
const handleViewVideoSubmit = event => {
  event.preventDefault();

  const myForm = event.target;
  const formData = new FormData(myForm);

  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(formData).toString()
  })
    .then(() => {
			// clear form
			myForm.reset();
			// hide form modal
			$('#coagadexOnDemandFormModal').modal('hide')
			// show video modal
			$('#coagadexOnDemandModal').modal('show')
		})
    .catch(error => alert(error));
};

const onDemandForm = document.querySelector("#coagadexOnDemandFormModal form")
if (onDemandForm) onDemandForm.addEventListener("submit", handleViewVideoSubmit);
